// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asd__day[data-v-67b4e0f1],.asd__day--disabled[data-v-67b4e0f1],.asd__day--empty[data-v-67b4e0f1]{opacity:1!important}", ""]);
// Exports
module.exports = exports;
